import EditIcon from '@mui/icons-material/Edit'
import { Box, Typography } from '@mui/material'
import { GetCompanyQuery } from '__generated__/graphql'
import React, { Fragment, useState } from 'react'
import useIsMobile from 'shared/hooks/useIsMobile'
import EditFundInfo from '../EditFundInfo'
import {
    Container,
    Header,
    NoDataBox,
    StyledCard,
    StyledCell,
    StyledHeader,
    StyledRow,
} from './styled'

interface FundInfoProps {
    data: GetCompanyQuery
    refetch: () => void
}

const FundInformation: React.FC<FundInfoProps> = ({ data, refetch }) => {
    const funds = data?.company?.companyFunds || []
    const limitedFunds = funds.slice(0, 5)
    const [edit, setEdit] = useState(false)
    const isMobile = useIsMobile()
    return (
        <Fragment>
            <EditFundInfo
                fundInfo={funds}
                open={edit}
                onClose={() => setEdit(false)}
                refetch={refetch}
            />
            <Container>
                <Header>
                    <Typography variant="h4">Fund Information</Typography>

                    {!isMobile && (
                        <EditIcon
                            color="action"
                            fontSize="small"
                            onClick={() => setEdit(true)}
                            sx={{ cursor: 'pointer' }}
                        />
                    )}
                </Header>

                {limitedFunds.length > 0 ? (
                    <StyledCard>
                        <StyledHeader>
                            <StyledRow>
                                <StyledCell>
                                    <Typography
                                        textAlign="left"
                                        variant="subtitle2"
                                    >
                                        Fund Name
                                    </Typography>
                                </StyledCell>
                                <StyledCell>
                                    <Typography
                                        textAlign="left"
                                        variant="subtitle2"
                                    >
                                        Fund Year
                                    </Typography>
                                </StyledCell>
                                <StyledCell>
                                    <Typography
                                        textAlign="left"
                                        variant="subtitle2"
                                    >
                                        Fund Size
                                    </Typography>
                                </StyledCell>
                            </StyledRow>
                        </StyledHeader>

                        <Box>
                            {limitedFunds.map((fund, index) => (
                                <StyledRow key={index}>
                                    <StyledCell>
                                        <Typography
                                            noWrap
                                            textAlign="left"
                                            variant="body2"
                                        >
                                            {fund.name || '-'}
                                        </Typography>
                                    </StyledCell>
                                    <StyledCell>
                                        <Typography
                                            noWrap
                                            textAlign="left"
                                            variant="body2"
                                        >
                                            {fund.year || '-'}
                                        </Typography>
                                    </StyledCell>
                                    <StyledCell>
                                        <Typography
                                            noWrap
                                            textAlign="left"
                                            variant="body2"
                                        >
                                            {fund.fundSizeMillions
                                                ? `${fund.fundSizeMillions}M`
                                                : '-'}
                                        </Typography>
                                    </StyledCell>
                                </StyledRow>
                            ))}
                        </Box>
                    </StyledCard>
                ) : (
                    <NoDataBox>
                        <Typography variant="body2">
                            No fund information available
                        </Typography>
                    </NoDataBox>
                )}
            </Container>
        </Fragment>
    )
}

export default FundInformation
